import { render, staticRenderFns } from "./ProjectWireframes.vue?vue&type=template&id=77b55aea&scoped=true&"
import script from "./ProjectWireframes.vue?vue&type=script&lang=js&"
export * from "./ProjectWireframes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectWireframes.vue?vue&type=style&index=0&id=77b55aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b55aea",
  null
  
)

export default component.exports